// extracted by mini-css-extract-plugin
module.exports = {"Box":"CustomFadeBox_Box__WJN9s","Div":"CustomFadeBox_Div__11h5K","LargeDiv":"CustomFadeBox_LargeDiv__156Xz"};